<p-dialog [modal]="true" [closable]="true" [style.height]="290" [(visible)]="display" (onAfterHide)="cancel()"
  [closeOnEscape]="false" header="{{ data.header }}" (onHide)="cancel()" class="popup-mobile">
  <div class="confirmation-content">
    <div class="confirmation-title">
      <div>
        <span class="confirmation-modal-heading">Authority </span><span>{{ data.modalHeading }}</span>
      </div>
      <div class="request-reason">
        <div class="confirmation-modal-line">
          <span>{{ data.modalSecondline }}</span>
        </div>
        <div class="form-field" *ngIf="showReason || showRejectReason">
          <label *ngIf="showReason">Reason</label>
          <label *ngIf="showRejectReason">Reject Reason</label>
          <textarea name="" id="release-later-reason" [(ngModel)]="reasonValue" cols="30" rows="10"></textarea>
        </div>
      </div>
    </div>
  </div>

  <p-footer class="confirmation-footer">
    <button type="button" pButton label="Yes" (click)="accept()"></button>
    <button type="button" pButton (click)="cancel()" label="No" class="p-button-outlined"></button>
  </p-footer>
</p-dialog>